import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';
import ChildEntityTab from 'registry/child-entities/ChildEntityTab';
import ChildEntityTabState from 'registry/child-entities/ChildEntityTabState';

export default class ChildEntityTabView extends BufferTabView<ChildEntityTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override initialize(): void {
    // HACK: This is a huge hack to force-rerender the child entity tab if parent entity change affects
    // what's rendered on the tab.
    // TODO(BNCH-11186): Remove this hack after the downstream tab components listens to flux changes.
    this.listenTo(this.model.get('model'), 'change:archiveRecord change:folder', () => {
      unmountRootsAsync([this.reactRoot], () => {
        this.reactRoot = null;
      });
      this.rerender();
    });
  }

  rerender(): void {
    const parentEntity = this.model.get('model');
    const childSchemaId = this.model.get('childSchemaId');
    this.reactRoot = renderToDOM(
      <ChildEntityTab childSchemaId={childSchemaId} parentEntityId={parentEntity.id} />,
      this.el,
      this.reactRoot
    );
  }

  override render(): Backbone.View<ChildEntityTabState> {
    this.rerender();
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

ChildEntityTabView.prototype.className = 'buffer-tab';
